<div fxLayout="column" class="page-container">
  <div fxLayout="column" class="eon-backdrop" fxLayoutAlign="center center">
    <div class="content-container" fxLayoutAlign="center center" fxLayout="column">
      <h1 class="splash-headline" fxLayoutAlign="center center">Score Management</h1>
      <div class="table-container">
        <table mat-table matSort [dataSource]="dataSource">
          <ng-container matColumnDef="userName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>username</th>
            <td mat-cell *matCellDef="let score">{{score.userName}}</td>
          </ng-container>

          <ng-container matColumnDef="score">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>score</th>
            <td mat-cell *matCellDef="let score">{{score.score}}</td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>actions</th>
            <td mat-cell *matCellDef="let score" fxLayoutGap="24px">
              <eon-ui-button icon="trash_bin" size="small" (click)="deleteScore(score.userName)"></eon-ui-button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <mat-paginator [length]="dataSource.data.length" [pageSize]="10" [pageSizeOptions]="[5, 10, 20]">
        </mat-paginator>
      </div>
    </div>
  </div>
</div>
